export const slugify: (str: string) => string = (str: string) =>
  str ? str.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '') : ''

export const capitalizeFirstLetter = (input: string) => input.trim().length > 0 ? input.charAt(0).toUpperCase() + input.slice(1) : input

export const convertEmToPx = (em: number) => parseFloat(getComputedStyle(document.documentElement).fontSize) * em

export const noOp = (s: unknown): unknown => s;
